import { useEffect, useRef, useState } from "react";

const useEditObject = () => {
  const [isEditable, setIsEditable] = useState(false);
  const editObject = useRef({});

  useEffect(() => {
    editObject.current = {};
  }, [isEditable]);

  const editHandler = (fieldName, fieldValue) => {
    editObject.current = ({ ...editObject.current, [fieldName]: fieldValue });
  };

  const startEdit = () => setIsEditable(true);
  const stopEdit = () => setIsEditable(false);

  return {
    editObject,
    isEditable, startEdit, stopEdit,
    editHandler,
  };
};

export default useEditObject;